"use strict";
/* Generated by ts-generator ver. 0.0.8 */
/* tslint:disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.GebUniswapV3TwoTrancheManager = void 0;
var geb_contract_base_1 = require("@reflexer-finance/geb-contract-base");
var bignumber_1 = require("@ethersproject/bignumber");
var GebUniswapV3TwoTrancheManager = /** @class */ (function (_super) {
    __extends(GebUniswapV3TwoTrancheManager, _super);
    function GebUniswapV3TwoTrancheManager() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GebUniswapV3TwoTrancheManager.prototype.MAX_TICK = function (multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [], "name": "MAX_TICK", "outputs": [{ "internalType": "int24", "name": "", "type": "int24" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [], multicall);
    };
    GebUniswapV3TwoTrancheManager.prototype.MIN_TICK = function (multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [], "name": "MIN_TICK", "outputs": [{ "internalType": "int24", "name": "", "type": "int24" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [], multicall);
    };
    GebUniswapV3TwoTrancheManager.prototype.WETH9 = function (multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [], "name": "WETH9", "outputs": [{ "internalType": "address", "name": "", "type": "address" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [], multicall);
    };
    GebUniswapV3TwoTrancheManager.prototype.addAuthorization = function (account) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [{ "internalType": "address", "name": "account", "type": "address" }], "name": "addAuthorization", "outputs": [], "stateMutability": "nonpayable", "type": "function" };
        return this.getTransactionRequest(abi, [account]);
    };
    GebUniswapV3TwoTrancheManager.prototype.allowance = function (owner, spender, multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [{ "internalType": "address", "name": "owner", "type": "address" }, { "internalType": "address", "name": "spender", "type": "address" }], "name": "allowance", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [owner, spender], multicall);
    };
    GebUniswapV3TwoTrancheManager.prototype.approve = function (spender, amount) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [{ "internalType": "address", "name": "spender", "type": "address" }, { "internalType": "uint256", "name": "amount", "type": "uint256" }], "name": "approve", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "stateMutability": "nonpayable", "type": "function" };
        return this.getTransactionRequest(abi, [spender, amount]);
    };
    GebUniswapV3TwoTrancheManager.prototype.authorizedAccounts = function (address, multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [{ "internalType": "address", "name": "", "type": "address" }], "name": "authorizedAccounts", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [address], multicall);
    };
    GebUniswapV3TwoTrancheManager.prototype.balanceOf = function (account, multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [{ "internalType": "address", "name": "account", "type": "address" }], "name": "balanceOf", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [account], multicall);
    };
    GebUniswapV3TwoTrancheManager.prototype.decimals = function (multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [], "name": "decimals", "outputs": [{ "internalType": "uint8", "name": "", "type": "uint8" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [], multicall);
    };
    GebUniswapV3TwoTrancheManager.prototype.decreaseAllowance = function (spender, subtractedValue) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [{ "internalType": "address", "name": "spender", "type": "address" }, { "internalType": "uint256", "name": "subtractedValue", "type": "uint256" }], "name": "decreaseAllowance", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "stateMutability": "nonpayable", "type": "function" };
        return this.getTransactionRequest(abi, [spender, subtractedValue]);
    };
    GebUniswapV3TwoTrancheManager.prototype.delay = function (multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [], "name": "delay", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [], multicall);
    };
    GebUniswapV3TwoTrancheManager.prototype.deposit = function (ethValue, newLiquidity, recipient, minAm0, minAm1) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [{ "internalType": "uint256", "name": "newLiquidity", "type": "uint256" }, { "internalType": "address", "name": "recipient", "type": "address" }, { "internalType": "uint256", "name": "minAm0", "type": "uint256" }, { "internalType": "uint256", "name": "minAm1", "type": "uint256" }], "name": "deposit", "outputs": [{ "internalType": "uint256", "name": "mintAmount", "type": "uint256" }], "stateMutability": "payable", "type": "function" };
        return this.getTransactionRequest(abi, [newLiquidity, recipient, minAm0, minAm1], bignumber_1.BigNumber.from(ethValue));
    };
    GebUniswapV3TwoTrancheManager.prototype.fee = function (multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [], "name": "fee", "outputs": [{ "internalType": "uint24", "name": "", "type": "uint24" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [], multicall);
    };
    GebUniswapV3TwoTrancheManager.prototype.getNextTicks = function (_threshold) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [{ "internalType": "uint256", "name": "_threshold", "type": "uint256" }], "name": "getNextTicks", "outputs": [{ "internalType": "int24", "name": "_nextLower", "type": "int24" }, { "internalType": "int24", "name": "_nextUpper", "type": "int24" }, { "internalType": "int24", "name": "targetTick", "type": "int24" }], "stateMutability": "nonpayable", "type": "function" };
        return this.getTransactionRequest(abi, [_threshold]);
    };
    GebUniswapV3TwoTrancheManager.prototype.getPrices = function () {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [], "name": "getPrices", "outputs": [{ "internalType": "uint256", "name": "redemptionPrice", "type": "uint256" }, { "internalType": "uint256", "name": "tokenPrice", "type": "uint256" }], "stateMutability": "nonpayable", "type": "function" };
        return this.getTransactionRequest(abi, []);
    };
    GebUniswapV3TwoTrancheManager.prototype.getTargetTick = function () {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [], "name": "getTargetTick", "outputs": [{ "internalType": "int24", "name": "targetTick", "type": "int24" }], "stateMutability": "nonpayable", "type": "function" };
        return this.getTransactionRequest(abi, []);
    };
    GebUniswapV3TwoTrancheManager.prototype.getTicksWithThreshold = function (targetTick, _threshold, multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [{ "internalType": "int24", "name": "targetTick", "type": "int24" }, { "internalType": "uint256", "name": "_threshold", "type": "uint256" }], "name": "getTicksWithThreshold", "outputs": [{ "internalType": "int24", "name": "lowerTick", "type": "int24" }, { "internalType": "int24", "name": "upperTick", "type": "int24" }], "stateMutability": "pure", "type": "function" };
        return this.ethCallOrMulticall(abi, [targetTick, _threshold], multicall);
    };
    GebUniswapV3TwoTrancheManager.prototype.getToken0FromLiquidity = function (_liquidity) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [{ "internalType": "uint128", "name": "_liquidity", "type": "uint128" }], "name": "getToken0FromLiquidity", "outputs": [{ "internalType": "uint256", "name": "amount0", "type": "uint256" }], "stateMutability": "nonpayable", "type": "function" };
        return this.getTransactionRequest(abi, [_liquidity]);
    };
    GebUniswapV3TwoTrancheManager.prototype.getToken1FromLiquidity = function (_liquidity) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [{ "internalType": "uint128", "name": "_liquidity", "type": "uint128" }], "name": "getToken1FromLiquidity", "outputs": [{ "internalType": "uint256", "name": "amount1", "type": "uint256" }], "stateMutability": "nonpayable", "type": "function" };
        return this.getTransactionRequest(abi, [_liquidity]);
    };
    GebUniswapV3TwoTrancheManager.prototype.getTokenAmountsFromLiquidity = function (_liquidity) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [{ "internalType": "uint128", "name": "_liquidity", "type": "uint128" }], "name": "getTokenAmountsFromLiquidity", "outputs": [{ "internalType": "uint256", "name": "amount0", "type": "uint256" }, { "internalType": "uint256", "name": "amount1", "type": "uint256" }], "stateMutability": "nonpayable", "type": "function" };
        return this.getTransactionRequest(abi, [_liquidity]);
    };
    GebUniswapV3TwoTrancheManager.prototype.increaseAllowance = function (spender, addedValue) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [{ "internalType": "address", "name": "spender", "type": "address" }, { "internalType": "uint256", "name": "addedValue", "type": "uint256" }], "name": "increaseAllowance", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "stateMutability": "nonpayable", "type": "function" };
        return this.getTransactionRequest(abi, [spender, addedValue]);
    };
    GebUniswapV3TwoTrancheManager.prototype.lastRebalance = function (multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [], "name": "lastRebalance", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [], multicall);
    };
    GebUniswapV3TwoTrancheManager.prototype.maxLiquidityPerTick = function (multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [], "name": "maxLiquidityPerTick", "outputs": [{ "internalType": "uint128", "name": "", "type": "uint128" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [], multicall);
    };
    GebUniswapV3TwoTrancheManager.prototype.modifyParameters__Bytes32Address = function (parameter, data) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [{ "internalType": "bytes32", "name": "parameter", "type": "bytes32" }, { "internalType": "address", "name": "data", "type": "address" }], "name": "modifyParameters", "outputs": [], "stateMutability": "nonpayable", "type": "function" };
        return this.getTransactionRequest(abi, [parameter, data]);
    };
    GebUniswapV3TwoTrancheManager.prototype.modifyParameters__Bytes32Uint256 = function (parameter, data) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [{ "internalType": "bytes32", "name": "parameter", "type": "bytes32" }, { "internalType": "uint256", "name": "data", "type": "uint256" }], "name": "modifyParameters", "outputs": [], "stateMutability": "nonpayable", "type": "function" };
        return this.getTransactionRequest(abi, [parameter, data]);
    };
    GebUniswapV3TwoTrancheManager.prototype.name = function (multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [], "name": "name", "outputs": [{ "internalType": "string", "name": "", "type": "string" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [], multicall);
    };
    GebUniswapV3TwoTrancheManager.prototype.oracle = function (multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [], "name": "oracle", "outputs": [{ "internalType": "contract OracleForUniswapLike", "name": "", "type": "address" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [], multicall);
    };
    GebUniswapV3TwoTrancheManager.prototype.pool = function (multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [], "name": "pool", "outputs": [{ "internalType": "contract IUniswapV3Pool", "name": "", "type": "address" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [], multicall);
    };
    GebUniswapV3TwoTrancheManager.prototype.poolViewer = function (multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [], "name": "poolViewer", "outputs": [{ "internalType": "contract PoolViewer", "name": "", "type": "address" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [], multicall);
    };
    GebUniswapV3TwoTrancheManager.prototype.positions = function (uinteger, multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "name": "positions", "outputs": [{ "internalType": "bytes32", "name": "id", "type": "bytes32" }, { "internalType": "int24", "name": "lowerTick", "type": "int24" }, { "internalType": "int24", "name": "upperTick", "type": "int24" }, { "internalType": "uint128", "name": "uniLiquidity", "type": "uint128" }, { "internalType": "uint256", "name": "threshold", "type": "uint256" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [uinteger], multicall);
    };
    GebUniswapV3TwoTrancheManager.prototype.ratio1 = function (multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [], "name": "ratio1", "outputs": [{ "internalType": "uint128", "name": "", "type": "uint128" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [], multicall);
    };
    GebUniswapV3TwoTrancheManager.prototype.ratio2 = function (multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [], "name": "ratio2", "outputs": [{ "internalType": "uint128", "name": "", "type": "uint128" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [], multicall);
    };
    GebUniswapV3TwoTrancheManager.prototype.rebalance = function () {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [], "name": "rebalance", "outputs": [], "stateMutability": "nonpayable", "type": "function" };
        return this.getTransactionRequest(abi, []);
    };
    GebUniswapV3TwoTrancheManager.prototype.removeAuthorization = function (account) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [{ "internalType": "address", "name": "account", "type": "address" }], "name": "removeAuthorization", "outputs": [], "stateMutability": "nonpayable", "type": "function" };
        return this.getTransactionRequest(abi, [account]);
    };
    GebUniswapV3TwoTrancheManager.prototype.sqrt = function (y, multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [{ "internalType": "uint256", "name": "y", "type": "uint256" }], "name": "sqrt", "outputs": [{ "internalType": "uint256", "name": "z", "type": "uint256" }], "stateMutability": "pure", "type": "function" };
        return this.ethCallOrMulticall(abi, [y], multicall);
    };
    GebUniswapV3TwoTrancheManager.prototype.symbol = function (multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [], "name": "symbol", "outputs": [{ "internalType": "string", "name": "", "type": "string" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [], multicall);
    };
    GebUniswapV3TwoTrancheManager.prototype.tickSpacing = function (multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [], "name": "tickSpacing", "outputs": [{ "internalType": "int24", "name": "", "type": "int24" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [], multicall);
    };
    GebUniswapV3TwoTrancheManager.prototype.token0 = function (multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [], "name": "token0", "outputs": [{ "internalType": "address", "name": "", "type": "address" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [], multicall);
    };
    GebUniswapV3TwoTrancheManager.prototype.token1 = function (multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [], "name": "token1", "outputs": [{ "internalType": "address", "name": "", "type": "address" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [], multicall);
    };
    GebUniswapV3TwoTrancheManager.prototype.totalSupply = function (multicall) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [], "name": "totalSupply", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" };
        return this.ethCallOrMulticall(abi, [], multicall);
    };
    GebUniswapV3TwoTrancheManager.prototype.transfer = function (recipient, amount) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [{ "internalType": "address", "name": "recipient", "type": "address" }, { "internalType": "uint256", "name": "amount", "type": "uint256" }], "name": "transfer", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "stateMutability": "nonpayable", "type": "function" };
        return this.getTransactionRequest(abi, [recipient, amount]);
    };
    GebUniswapV3TwoTrancheManager.prototype.transferFrom = function (sender, recipient, amount) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [{ "internalType": "address", "name": "sender", "type": "address" }, { "internalType": "address", "name": "recipient", "type": "address" }, { "internalType": "uint256", "name": "amount", "type": "uint256" }], "name": "transferFrom", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "stateMutability": "nonpayable", "type": "function" };
        return this.getTransactionRequest(abi, [sender, recipient, amount]);
    };
    GebUniswapV3TwoTrancheManager.prototype.uniswapV3MintCallback = function (amount0Owed, amount1Owed, data) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [{ "internalType": "uint256", "name": "amount0Owed", "type": "uint256" }, { "internalType": "uint256", "name": "amount1Owed", "type": "uint256" }, { "internalType": "bytes", "name": "data", "type": "bytes" }], "name": "uniswapV3MintCallback", "outputs": [], "stateMutability": "nonpayable", "type": "function" };
        return this.getTransactionRequest(abi, [amount0Owed, amount1Owed, data]);
    };
    GebUniswapV3TwoTrancheManager.prototype.unwrapWETH9 = function (ethValue, amountMinimum, recipient) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [{ "internalType": "uint256", "name": "amountMinimum", "type": "uint256" }, { "internalType": "address", "name": "recipient", "type": "address" }], "name": "unwrapWETH9", "outputs": [], "stateMutability": "payable", "type": "function" };
        return this.getTransactionRequest(abi, [amountMinimum, recipient], bignumber_1.BigNumber.from(ethValue));
    };
    GebUniswapV3TwoTrancheManager.prototype.withdraw = function (liquidityAmount, recipient) {
        // prettier-ignore
        // @ts-ignore
        var abi = { "inputs": [{ "internalType": "uint256", "name": "liquidityAmount", "type": "uint256" }, { "internalType": "address", "name": "recipient", "type": "address" }], "name": "withdraw", "outputs": [{ "internalType": "uint256", "name": "amount0", "type": "uint256" }, { "internalType": "uint256", "name": "amount1", "type": "uint256" }], "stateMutability": "nonpayable", "type": "function" };
        return this.getTransactionRequest(abi, [liquidityAmount, recipient]);
    };
    return GebUniswapV3TwoTrancheManager;
}(geb_contract_base_1.BaseContractAPI));
exports.GebUniswapV3TwoTrancheManager = GebUniswapV3TwoTrancheManager;
